import { createAsyncThunk } from '@reduxjs/toolkit';
import { setUserId } from '@snowplow/browser-tracker';

import { reset } from '@/rootActions';
import { errorHandling } from '@/services/errorHandling';
import { history } from '@/services/history';
import { deleteCookie } from '@/shared/utils/cookie';
import { AUTH_COOKIE_KEY } from '@/shared/utils/session';

import { authAPI } from '../api';
import { authClientV3 } from '../api/v3';
import { AUTH_MODES, getAuthMode } from '../mode';
import { namespace as authNamespace } from '../namespace';

export const signOut = createAsyncThunk(`${authNamespace}/signOut`, async (_, { dispatch }) => {
  if (getAuthMode() === AUTH_MODES.V3) {
    // The signedOut subscription in create-onboarding-wizard resets the app.
    await authClientV3.signOut();

    return;
  }

  // Signing out of the legacy stack also removes its session record, so the
  // mode flips to V3 and the next sign-in goes through the email-first flow.
  deleteCookie(AUTH_COOKIE_KEY);
  await authAPI.signOut();
  dispatch(reset());
  errorHandling.clearIdentity();
  setUserId(null);
  history.replace('/login');
});
